import React from "react";
import { Grid, TextField } from "@mui/material";

export default function BatchDateRangeFields({ batchStart, batchEnd, setBatchStart, setBatchEnd }) {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={4}>
        <TextField
          label="Fecha inicio"
          type="date"
          value={batchStart}
          onChange={(e) => setBatchStart(e.target.value)}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          label="Fecha fin"
          type="date"
          value={batchEnd}
          onChange={(e) => setBatchEnd(e.target.value)}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
  );
}
